// Single source of truth for the left-nav item definitions, shared by the
// GlobalRail (platform-scoped) and SiteWorkspaceNav (site-scoped) components.
// Setup is NOT listed here — it is injected at render time (with the
// incomplete/complete status dot) by GlobalRail.

import {
  IconAffiliate,
  IconArticle,
  IconBook,
  IconBulb,
  IconChartBar,
  IconCloud,
  IconHelp,
  IconHome,
  IconLayoutDashboard,
  IconQuote,
  IconRoute,
  IconSettings,
  IconTemplate,
  IconWorld,
} from '@/lib/icons';

export type IconComponent = typeof IconHome;

export interface NavItem {
  // For SITE_NAV: relative sub-path (e.g. 'drafts', or '' for the Hub).
  // For PLATFORM_NAV: absolute path (e.g. '/sites').
  to: string;
  label: string;
  icon: IconComponent;
  end?: boolean;
  healthDot?: 'sites' | 'settings';
  alertCounter?: boolean;
  // When true, RailItem renders the live in-flight publish count (accent pill).
  queueCounter?: boolean;
}

export const SITE_NAV: NavItem[] = [
  { to: '', label: 'Hub', icon: IconLayoutDashboard, end: true },
  { to: 'brainstorm', label: 'Brainstorm', icon: IconBulb },
  { to: 'pipeline', label: 'Pipeline', icon: IconRoute },
  { to: 'drafts', label: 'Drafts', icon: IconBook },
  { to: 'articles', label: 'Articles', icon: IconArticle },
  { to: 'content-graph', label: 'Content Graph', icon: IconAffiliate },
  { to: 'analytics', label: 'Analytics', icon: IconChartBar },
  { to: 'prompts', label: 'Prompts', icon: IconQuote },
];

// Alerts is intentionally NOT here: it lives in the header as a bell + count
// badge next to Help (see Header.tsx), which reads more naturally than a rail
// nav item and gives the unread indicator a home. `alertCounter` on NavItem is
// retained for the generic RailItem badge affordance.
export const PLATFORM_NAV: NavItem[] = [
  { to: '/sites', label: 'Sites', icon: IconWorld, healthDot: 'sites' },
  { to: '/queue', label: 'Publish queue', icon: IconCloud, queueCounter: true },
  { to: '/prompts', label: 'Prompt Templates', icon: IconTemplate, end: true },
  { to: '/settings', label: 'Settings', icon: IconSettings, healthDot: 'settings' },
];

// PLATFORM_HELP is rendered last in the Platform section — below every
// PLATFORM_NAV entry and below the Setup pin when present.
export const PLATFORM_HELP: NavItem = { to: '/help', label: 'Help', icon: IconHelp };
